import { cn } from '@/lib/utils';
import { getStatusConfig, normalizeStatus } from '@/lib/status-config';

interface StatusBadgeProps {
  status: string;
  variant?: 'default' | 'compact' | 'icon-only';
  className?: string;
}

/**
 * Unified status badge with icon and label.
 * Handles legacy status values transparently.
 */
export function StatusBadge({
  status,
  variant = 'default',
  className,
}: StatusBadgeProps) {
  const config = getStatusConfig(normalizeStatus(status));
  const Icon = config.icon;

  if (variant === 'icon-only') {
    return (
      <span
        className={cn(
          'inline-flex items-center justify-center rounded-full p-1',
          config.badgeClasses,
          className
        )}
        title={config.label}
      >
        <Icon className="h-3.5 w-3.5" />
      </span>
    );
  }

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium',
        config.badgeClasses,
        className
      )}
    >
      <Icon className="h-3 w-3" />
      {variant === 'compact' ? config.shortLabel : config.label}
    </span>
  );
}
